import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';

export default {
    install(Vue) {

        let startedPromise = null;
        let reconnectEnabled = true;
        let startCallbacks = [];

        function getToken() { return Vue.prototype.$auth.token(); }

        function startConnection() {
                startedPromise = connection.start().catch(err => {
                    console.error('Failed to connect with hub', err);
                    return new Promise((resolve, reject) =>
                        reconnectEnabled ? setTimeout(() => startConnection().then(resolve).catch(reject), 5000) : null);
                });
            
            return startedPromise;
        }

        function handleConnectionClose() { if (reconnectEnabled) { startConnection(); } }

        function handleAuthChange(isAuthenticated) {
            reconnectEnabled = isAuthenticated;
            if (isAuthenticated) {
                if (startedPromise == null) {
                    startConnection().then(callbackStartCallbacks);
                }
            }
            else connection.stop();
        }

        function callbackStartCallbacks() {
            startCallbacks.forEach(function (callback) {
                callback();
            });
        }

        function registerCallback() {
            startCallbacks.push(this.signalRStart);
            if (startedPromise != null) {
                startedPromise.then(this.signalRStart);
            }
        }

        const connection = new HubConnectionBuilder()
            .withUrl("https://signalr-beta.kms.uk.net/commsenginehub", { accessTokenFactory: getToken })
            .configureLogging(LogLevel.Warning)
            .build();

        connection.onclose(handleConnectionClose);

        
        Vue.prototype.$commsEngineHub = connection;
        Vue.prototype.$commsEngineHubStartRegistration = registerCallback;

        Vue.mixin({
            created() {
                if (!this.$parent) {
                    this.$watch(() => this.$auth.check(), handleAuthChange);
                }
            }
        });
    }
}
